import PageTitle from "../components/PageTitle.jsx";

export default function ServiceLayout(params) {
    return (
        <div className="flex h-[100dvh] overflow-hidden">
            <main className="grow">
                <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">
                    {params.title && <PageTitle>{params.title}</PageTitle>}
                    {params.children}
                </div>
            </main>
        </div>
    );
}
